<app-logiciel-caisse-list-toolbar
  [(searchTerm)]="searchTerm"
  (searchTermChange)="applySearch()"
  primaryLabel="+ Nouvel établissement"
  (primaryClick)="openCreate(etabModal)"
></app-logiciel-caisse-list-toolbar>

<div class="table-full-width">
  <div class="table-responsive lc-table-scroll">
    <table class="table table-hover pos-ticket-table">
      <thead class="custom-header">
        <tr>
          <th>Code</th>
          <th>Libellé</th>
          <th>Raison sociale</th>
          <th>NIF</th>
          <th>Entrepôts associés</th>
          <th style="width: 120px">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngIf="loading" class="lc-loading-row">
          <td colspan="6">
            <span class="spinner-border spinner-border-sm mr-1"></span>
            Chargement…
          </td>
        </tr>
        <tr *ngFor="let row of filteredRows" [hidden]="loading">
          <td>{{ row.code_etablissement }}</td>
          <td>{{ row.libelle }}</td>
          <td>{{ row.raison_sociale || '—' }}</td>
          <td>{{ row.numero_identification_fiscale || '—' }}</td>
          <td>{{ entrepotsSummary(row) }}</td>
          <td class="d-flex align-items-center flex-nowrap">
            <button
              type="button"
              class="btn btn-sm btn-icon btn-outline-primary mr-50"
              title="Modifier"
              (click)="openEdit(row, etabModal)"
            >
              <i data-feather="edit" [size]="16"></i>
            </button>
            <button
              type="button"
              class="btn btn-sm btn-icon btn-outline-primary mr-50"
              title="Entrepôts associés"
              (click)="openAssociation(row, assocModal)"
            >
              <i data-feather="link" [size]="16"></i>
            </button>
            <button
              type="button"
              class="btn btn-sm btn-icon btn-outline-danger"
              title="Supprimer"
              (click)="deleteRow(row)"
            >
              <i data-feather="trash-2" [size]="16"></i>
            </button>
          </td>
        </tr>
        <tr *ngIf="!loading && filteredRows.length === 0" class="lc-empty-row">
          <td colspan="6">Pas de données à afficher</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<ng-template #etabModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title">{{ editId ? 'Modifier' : 'Créer' }} établissement</h4>
    <button type="button" class="close" (click)="modal.dismiss()"><span>&times;</span></button>
  </div>
  <div class="modal-body" [formGroup]="form">
    <div class="row">
      <div class="col-md-6 form-group">
        <label>Libellé <span class="text-danger">*</span></label>
        <input class="form-control" formControlName="libelle" />
      </div>
      <div class="col-md-6 form-group">
        <label>Code établissement <span class="text-danger">*</span></label>
        <input class="form-control" formControlName="code_etablissement" />
      </div>
      <div class="col-md-6 form-group">
        <label>Raison sociale</label>
        <input class="form-control" formControlName="raison_sociale" />
      </div>
      <div class="col-md-6 form-group">
        <label>Numéro d'identification fiscale</label>
        <input class="form-control" formControlName="numero_identification_fiscale" />
      </div>
    </div>
    <hr class="my-2" />
    <p class="text-muted small mb-2">Adresse</p>
    <div class="row">
      <div class="col-md-6 form-group">
        <label>Pays</label>
        <input class="form-control" formControlName="pays" />
      </div>
      <div class="col-md-6 form-group">
        <label>Ville</label>
        <input class="form-control" formControlName="ville" />
      </div>
      <div class="col-md-4 form-group">
        <label>Code postal</label>
        <input class="form-control" formControlName="code_postal" />
      </div>
      <div class="col-md-8 form-group mb-0">
        <label>Adresse</label>
        <input class="form-control" formControlName="adresse" />
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary" (click)="modal.dismiss()">Annuler</button>
    <button type="button" class="btn btn-primary" (click)="save(modal)" [disabled]="saving || form.invalid">
      Enregistrer
    </button>
  </div>
</ng-template>

<ng-template #assocModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Association établissement / entrepôts</h4>
    <button type="button" class="close" (click)="modal.dismiss()"><span>&times;</span></button>
  </div>
  <div class="modal-body">
    <p class="text-muted mb-2" *ngIf="associationRow">
      Établissement :
      <strong>{{ associationRow.libelle }}</strong>
      <span class="text-muted">({{ associationRow.code_etablissement }})</span>
    </p>
    <p class="text-muted small mb-3">
      Un entrepôt ne peut être rattaché qu'à un seul établissement.
    </p>
    <div class="form-group mb-0">
      <label>Entrepôts</label>
      <ng-select
        [items]="entrepotOptions"
        bindLabel="label"
        bindValue="id"
        [multiple]="true"
        [closeOnSelect]="false"
        placeholder="Sélectionner des entrepôts"
        [(ngModel)]="associationEntrepotIds"
      ></ng-select>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary" (click)="modal.dismiss()">Annuler</button>
    <button
      type="button"
      class="btn btn-primary"
      (click)="saveAssociation(modal)"
      [disabled]="associationSaving"
    >
      Enregistrer
    </button>
  </div>
</ng-template>
